// extracted by mini-css-extract-plugin
export default {"badge":"BadgeUi-module__badge__dQ3mG","badge__primary":"BadgeUi-module__badge__primary__GLifo"};